import * as React from "react";
import { SVGProps } from "react";
export function GlobeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#globe_svg__a)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx={7} cy={7} r={5.833} />
        <path d="M7 1.167c-1.792 1.75-1.792 9.916 0 11.666 1.792-1.75 1.792-9.916 0-11.666ZM1.167 7h11.666" />
      </g>
      <defs>
        <clipPath id="globe_svg__a">
          <path fill="#fff" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
